/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_SuccessInputs */



/**
* | output |
* | --- |
* | "Successfully upgraded to Team!" |
*
* @param {Plan_Upgrade_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_success = /** @type {((inputs?: Plan_Upgrade_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfolgreich auf Team upgraded!")
	return /** @type {LocalizedString} */ ("Successfully upgraded to Team!")
});